import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getToken, removeToken, setToken, valiadteToken } from '../../shared/utils/utils';
import moment from 'moment';
import { act } from 'react-dom/test-utils';

interface AuthState {
	isLoading: boolean;
	isLoggedin: boolean;
	isEmailValid: boolean;
	isLoggedout: boolean;
	userData: any;
	dashBordData: any;
	totalNotification: number;
	notificationList: any;
	roleandPermission: any;
	dashBordEarningData: any;
}

const initialState: AuthState = {
	isLoading: false,
	isLoggedin: valiadteToken(),
	isEmailValid: false,
	isLoggedout: false,
	userData: {},
	dashBordData: {},
	totalNotification: 0,
	notificationList: [],
	roleandPermission: getToken('Manage') ? JSON.parse(getToken('Manage') as string) : [],
	dashBordEarningData: {}
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		// validateUser: state => {
		// 	state.isLoggedin = valiadteToken();
		// },
		loginInit: state => {
			state.isLoading = true;
		},
		loginSucess: (state, action: PayloadAction<any>) => {
			const data = action.payload;
			const { accessToken, refreshToken } = data.data;

			setToken('login-auth-token', accessToken.toString()).then(() => {
				setToken('refreshToken', refreshToken.toString());
				setToken('isLoggedIn', 'true');
				const date = moment(new Date().getTime()).add(24, 'hours').valueOf();
				setToken('exp', date.toString());
			});

			state.isLoading = false;
			state.isLoggedin = true;
			state.isLoggedout = false;
			// state.user = action.payload;
		},
		loginError: state => {
			// console.log('from fail rwediux');
			state.isLoading = false;
			// state.user = null;
		},
		forgotPasswordInit: state => {
			state.isLoading = true;
			state.isEmailValid = false;
		},
		forgotPasswordSucess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.isEmailValid = true;
		},
		forgotPasswordError: state => {
			// console.log('from fail rwediux');
			state.isLoading = false;
			state.isEmailValid = false;
		},
		logOutInit: state => {
			state.isLoading = true;
			state.isLoggedout = false;
		},
		logOutSuccess: state => {
			state.isLoading = false;
			state.isLoggedout = true;
			state.isLoggedin = false;
			removeToken('login-auth-token');
			removeToken('refreshToken');
			removeToken('isLoggedIn');
			removeToken('exp');

			window.location.replace('/');
		},
		logOutError: state => {
			state.isLoading = false;
			state.isLoggedout = false;
		},
		getUserdataInit: state => {
			// state.userData = {};
		},
		getUserdataSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;

			const roleAndPermission =
				(data.details.permissionData && [
					...data.details.permissionData.role.permissions
				]) ||
				[];
			setToken('Manage', JSON.stringify(roleAndPermission));
			// console.log(data, 'user');
			state.roleandPermission = roleAndPermission;
			state.userData = { ...data.details };
		},
		getUserdataError: state => {
			state.userData = {};
			state.roleandPermission = [];
		},
		editUserDataInit: state => {
			state.isLoading = true;
		},
		editUserDataSuccess: (state, action: PayloadAction<any>) => {
			// console.log('state', action.payload);
			state.userData = { ...state.userData, ...action.payload };
			state.isLoading = false;
		},
		editUserDataError: state => {
			state.isLoading = false;
		},
		getdashboardDataInIt: state => {
			state.isLoading = true;
		},
		getdashboardDataSuccess: (state, action: PayloadAction<any>) => {
			// console.log(action.payload.data);
			state.isLoading = false;
			state.dashBordData = { ...action.payload.data };
		},
		getdashboardDataError: state => {
			state.isLoading = false;
		},
		changepasswordInIt: state => {
			state.isLoading = true;
		},
		changepasswordSuccess: state => {
			state.isLoading = false;
		},
		changepasswordError: state => {
			state.isLoading = false;
		},
		getHeaderNotificationInIt: state => {
			// state.isLoading = true;
			state.notificationList = [];
			state.totalNotification = 0;
		},
		getHeaderNotificationSuccess: (state, action: PayloadAction<any>) => {
			// state.isLoading = false;
			const data = action.payload.data;
			state.notificationList = [...data.notifications];
			state.totalNotification = data.count;
		},
		getHeaderNotificationError: state => {
			state.totalNotification = 0;
			state.notificationList = [];
			// state.isLoading = false;
		},
		readNotificationInIt: state => {
			state.isLoading = true;
		},
		readNotificationSuccess: state => {
			state.isLoading = true;
		},
		readNotificationError: state => {
			state.isLoading = true;
		},
		resetPasswordInit: state => {
			state.isLoading = true;
		},
		resetPasswordSuccess: state => {
			state.isLoading = false;
		},
		resetPasswordError: state => {
			state.isLoading = false;
		},





		getdashboardEarningDataInIt: state => {
			state.isLoading = true;
		},
		getdashboardEarningDataSuccess: (state, action: PayloadAction<any>) => {
			// console.log(action.payload.data);
			state.isLoading = false;
			state.dashBordEarningData = { ...action.payload.data };
		},
		getdashboardEarningDataError: state => {
			state.isLoading = false;
		},
	}
});
export const {
	getdashboardEarningDataInIt,
	getdashboardEarningDataSuccess,
	getdashboardEarningDataError,
	loginSucess,
	loginError,
	loginInit,
	forgotPasswordError,
	forgotPasswordInit,
	forgotPasswordSucess,
	// validateUser,
	logOutError,
	logOutInit,
	logOutSuccess,
	getUserdataError,
	getUserdataInit,
	getUserdataSuccess,
	editUserDataError,
	editUserDataInit,
	editUserDataSuccess,
	getdashboardDataError,
	getdashboardDataInIt,
	getdashboardDataSuccess,
	changepasswordError,
	changepasswordInIt,
	changepasswordSuccess,
	getHeaderNotificationError,
	getHeaderNotificationInIt,
	getHeaderNotificationSuccess,
	readNotificationError,
	readNotificationInIt,
	readNotificationSuccess,
	resetPasswordError,
	resetPasswordInit,
	resetPasswordSuccess
} = authSlice.actions;
export default authSlice.reducer;
